export const environment = {
    production: true,
    baseHref: '/',
    domain_url: '/',
    api_url: 'https://drci5ihael.execute-api.us-west-1.amazonaws.com/dev/',
    slug:"production"
};
